import { ethers } from 'ethers';
import { TxStatus } from '@orionprotocol/sdk';

import {
  txOnChainCallbacks,
  txOnErrorCallbacks,
  txOnFailCallbacks,
  txOnFinalCallbacks,
  txOnSentCallbacks,
  txOnSuccessCallbacks,
} from './transactionCallbacks';

export type TransactionActions = {
  onTxSent?: ({
    txId,
    txResponse,
  }: {
    txId: string;
    txResponse: ethers.TransactionResponse;
  }) => void;
  onTxIncludedInChain?: (txId: string) => void;
  onTxFail?: ({ txId, status }: { txId: string; status?: TxStatus }) => void;
  onTxSuccess?: ({
    txId,
    txReceipt,
  }: {
    txId: string;
    txReceipt: ethers.TransactionReceipt;
  }) => void;
  onTxError?: ({ txId, error }: { txId: string; error: Error }) => void;
  onTxFinal?: (txId: string) => void;
};
export const handleTransactionActions = ({
  id,
  onTxIncludedInChain,
  onTxSent,
  onTxFail,
  onTxSuccess,
  onTxError,
  onTxFinal,
}: TransactionActions & {
  id: string;
}): void => {
  if (onTxIncludedInChain !== undefined) {
    txOnChainCallbacks.set(id, () => {
      onTxIncludedInChain(id);
      txOnChainCallbacks.delete(id);
    });
  }

  if (onTxSent) {
    txOnSentCallbacks.set(id, (txResponse) => {
      onTxSent({ txId: id, txResponse });
      txOnSentCallbacks.delete(id);
    });
  }

  if (onTxFail) {
    txOnFailCallbacks.set(id, (status) => {
      onTxFail({ txId: id, status });
      txOnFailCallbacks.delete(id);
    });
  }

  if (onTxSuccess) {
    txOnSuccessCallbacks.set(id, (txReceipt) => {
      onTxSuccess({ txId: id, txReceipt });
      txOnSuccessCallbacks.delete(id);
    });
  }

  if (onTxError) {
    txOnErrorCallbacks.set(id, (error) => {
      onTxError({ txId: id, error });
      txOnErrorCallbacks.delete(id);
    });
  }

  if (onTxFinal) {
    txOnFinalCallbacks.set(id, () => {
      onTxFinal(id);
      txOnFinalCallbacks.delete(id);
    });
  }
};
